<template>
  <mw-dialog ref="dialog" size="form" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <div class="__form_content" ref="abc">
      <el-row class="__comment_top" :class="{'comment-expend':isCommentExpaned}">
        <el-col :span="7"  class="__direction">
          <div class="__left-box" :class="{'__not_notice':!showCircular}">
            <div class="__notice_top" :class="{'__flow_panel_01':(showNormal && !showSubProcess),
            '__flow_panel_02':(!showNormal && showSubProcess)}">
              <div class="__left01" v-if="showNormal">
                <div class="__panel">
                  <div class="__panel-heading">{{$lang("下一环节(单选)")}}</div>
                  <div class="__panel-body">
                    <li class="__item" :class="{'__active':(curFlowId==n.id),'__disable':n.$disabled?n.$disabled:false}"  v-for="n in normalFlow" @click="flowClick(n,$event,'normal')" :title="transFlowName(n.name)"  v-html="transFlowName(n.name)"></li>
                  </div>
                </div>
              </div>
              <div class="__left02" v-if="showSubProcess">
                <div class="__panel">
                  <div class="__panel-heading"  style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{$lang("并行发送(多选)")}}</div>
                  <div class="__panel-body">
                    <li class="__item" :class="{'__active':(curFlowId==n.id),'__disable':n.$disabled?n.$disabled:false}" v-for="n in subProcessFlow" @click="flowClick(n,$event,'sub')" :title="transFlowName(n.name)"  v-html="transFlowName(n.name)"></li>
                  </div>
                </div>
              </div>
              <div class="mw-panel" v-if="!showNormal && !showSubProcess">
                <div>{{$lang("未获取到符合条件的流向信息")}}</div>
              </div>
            </div>
            <div class="__notice" v-if="showCircular">
              <div class="__panel">
                <div class="__panel-heading">{{$lang("传阅")}}</div>
                <div class="__panel-body">
                  <li class="__item" :class="{'__active':(curFlowId==n.id)}" v-for="n in circularFlow" @click="flowClick(n,$event,'circular')"  v-html="transFlowName(n.name)"></li>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="17" class="__col-h100">
          <el-row class="__col-h100">
            <el-col :span="11" class="__col-h100">
              <div class="__panel __tree-panel">
                <div class="__panel-heading">
                  <div style="display: inline-block;width: calc(100% - 250px);white-space: nowrap;
                      text-overflow: ellipsis;overflow: hidden;
                     ">{{$lang("备选")}}
                  </div>
                  <span class="pull-right" style="width:250px;overflow:hidden;white-space:nowrap;height:30px;">({{$lang("双击移入")}}>>)&nbsp;
                      <el-checkbox style="font-size:12px;margin-right:50px;" v-model="checkedSelectAll"  v-if="showSelectAllBtn" @change="selectAll">全选</el-checkbox>
                  </span>
                </div>
                <div class="__panel-body">
                  <!--<template>-->
                    <mw-complete-tree  v-for="(value,key) in deptTreePanel" :rootData="value.rootData" :autoSelectSingle="true" :autoSelectData="autoSelectData"
                      :url="value.url" :defaultParams="value.defaultParams" :businessId='params.businessId' :batchId="params.batchId" :activityId="value.activityId" :async="true" :multiple="value.multiple"
                             :expandedFirst="true" :taskId="params.taskId" :type="value.type" :flowCount="flowCount" @dblClick="dblClick" :ref="'tree'+key" :key="key" v-show="value.vshow" v-if="value.vif"></mw-complete-tree>
                  <!--</template>-->
                </div>
              </div>
            </el-col>
            <el-col :span="2" class="__col-h100">
              <div class="__sel">
                <el-button type="primary" :title="$lang('选择')" class="__btn" @click="selectClick">&gt;&gt;</el-button>
                <br><br>
                <el-button type="primary" :title="$lang('移除')" class="__btn" @click="deselectClick">&lt;&lt;</el-button>
              </div>
            </el-col>
            <el-col :span="11" class="__col-h100">
              <div class="__panel __tree-panel">
                <div class="__panel-heading">{{$lang("选中")}}({{$lang("双击移出")}})</div>
                <div class="__panel-body">
                  <mw-complete-selected-tree :autoLoad="true" :async="false" :multiple="true"
                     ref="selectedTree" :treeData="allSelectTreeData"  @dblClick="dblClickSelected" :expandedFirst="true" ></mw-complete-selected-tree>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <template v-if="!customBottom">
      <el-row class="__comment" :class="{'comment-expend':isCommentExpaned}" >
        <el-col :span="5" class="__col-h100" v-if="!hideAttention">
          <div class="__field-set">
            <!--<div class="__title">{{$lang("提醒")}}</div>-->
            <template v-if="tipOptions.length > 0">
             <div class="__title" >{{$lang("提醒")}}</div>
             <div>
               <el-checkbox-group v-model="tipCheckList">
                  <template v-for="option in tipOptions">
                    <el-checkbox  :label="option.value">{{$lang(option.text)}}</el-checkbox>
                    <span style="color:blue;cursor:pointer;font-size: 13px;" v-if="option.canEdit" @click="editMsg" cname="notifySMS">编辑</span>
                  </template>
               </el-checkbox-group>
             </div>
            </template>
            <div class="__notice_all" v-else>
              <div style="position:absolute;width:150px;height:40px;top:50%;margin-top:-20px;left:50%;margin-left:-75px;">
                <el-checkbox style="overflow: hidden;text-overflow:ellipsis;" v-model="isAddAttention" border>{{$lang("我要关注")}}</el-checkbox>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="hideAttention?24:19" class="__col-h100" >
          <div class="__field-set" style="margin-right: 0px;">
            <div class="__title">{{$lang("意见")}}</div>
            <el-input
              type="textarea" resize="none" :disabled="disabledComment" v-model="comment" class="__col-h100" style="margin-top:2px;">
            </el-input>
          </div>
        </el-col>
      </el-row>
      </template>
      <template v-else>
        <el-row class="__comment" :class="{'comment-expend':isCommentExpaned}"  ref="customBottom" >
        </el-row>
      </template>
    </div>
    <div slot="footer" class="pull-left" style="display:inline-block" v-if="!customBottom">
      <el-button size="mini" @click="toggleCommentExpaned">{{isCommentExpaned?$lang("缩小意见框"):$lang("放大意见框")}}</el-button>
    </div>
  </mw-dialog>
</template>
<script>

import MwCompleteTree from "./tree/index.vue";
import * as bpmTaskApi from 'common/api/bpm-task';
import MwCompleteSelectedTree from "./tree/selected.vue";
import _ from 'lodash';

export default {
  components: {
    MwCompleteSelectedTree,
    MwCompleteTree},
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me=this;
    let tipOptions = [];
    let tipCheckList = [];
    let tipContent = "";
    if(window.$Env && $Env.compleDialogLeftTipOptions){
      tipOptions = $Env.compleDialogLeftTipOptions;
      _.each(tipOptions,function(v){
        if(v.checked) tipCheckList.push(v.value);
      })
      var temp = $Env.compleDialogMsgTemplete || '您好！现有$$sender将"$$businessName"事项发给了您，请您抽时间处理。';
      tipContent = temp.replace('$$businessName',(me.params.businessName || "")).replace(new RegExp('\\$\\$sender',"gm"),PF.userInfo.initusername);
    }
    return {
      title:$lang('选择流向'),
      curFlowId:undefined,
      curFlowName:'',
      allFlow:[],
      normalFlow:[],
      subProcessFlow:[],
      circularFlow:[],
      isCommentExpaned:false,
      isAddAttention:false,
      customBottom:false,
      autoSelectData:false,
      hideAttention:false,//添加我要关注的条件隐藏
      allSelectTreeData:[],
      deptTreePanel:{},
      curTreePanel:undefined,
      customBottomComp:undefined,
      showCircular:false,
      showNormal:false,
      showSubProcess:false,
      tipCheckList:tipCheckList,
      tipContent:tipContent,
      tipOptions:tipOptions,
      commentId:'',
      comment:'',
      commentCategory:'',
      flowCount:0,
      disabledComment:false,
      showSelectAllBtn:false,
      checkedSelectAll:false,
      isSubmitSingleFlow:false,//是否直接完成单流向单人员不弹出完成框
      footerButton:[
        {
          label: $lang("确定"),
          loading:false,
          func:me.submit
        },{
          label: $lang("关闭"),
          type: "default",
          func:me.close
        }],
    }
  },
  mounted() {
    let me=this;
    var completeDialogBottomCompId = me.params.completeDialogBottomCompId;
    if(completeDialogBottomCompId ){
      me.customBottom = true;
      me.isCommentExpaned = true;
      me.customBottomComp =PF.createVue({
        template:"<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
        data:{
          pageId:completeDialogBottomCompId,
          params : me.params
        }
      });
    }else{
      if (window.localStorage) {
        me.isCommentExpaned=localStorage.getItem("flow.complete.isCommentExpaned")!=="0";
      }
      if(window.$Env && $Env.hideAttention){
        me.hideAttention = true;
      }
    }


   /* setTimeout(()=>{
      this.show();
    },200);*/
    this.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    //去掉了，用公共的$lang
    /*lang(a,b) {
      return window.$lang?$lang(a,b):(a||b);
    },*/
    transFlowName(name) {
      if(!name)return "";
      if (name.indexOf('-') > 0) {
        let arr=name.split('-');
        return $lang(arr[0])+'-'+$lang(arr[1]);
      } else {
        return $lang(name);
      }
    },
    toggleCommentExpaned() {
      this.isCommentExpaned=!this.isCommentExpaned;
      if(window.localStorage)localStorage.setItem("flow.complete.isCommentExpaned", this.isCommentExpaned ? "1" : "0");
    },
    setBtnLoading(loading,idx){
      if(!loading && this.params.secondfunc && this.isSubmitSingleFlow)this.params.secondfunc();
      this.footerButton[idx].loading=loading;
    },
    editMsg(){
      this.$prompt('', $lang('编辑提醒内容'), {
        confirmButtonText: $lang('确定'),
        cancelButtonText: $lang('取消'),
        inputType:"textarea",
        customClass:'prompt-dialog-big-input',
        inputPattern:/\S+/,
        inputValue: this.tipContent,
        inputPlaceholder:$lang("请输入提醒内容"),
        inputErrorMessage:$lang("请输入提醒内容")
      }).then(({ value }) => {
        this.tipContent = value;
      }).catch(() => {

      });
    },
    submit:_.debounce(function(){
       let me=this;
        me._submit();
      }, 1000, {
        'leading': true,
        'trailing': false
      })
    ,
    _submit(){
      let me=this;
      if(!me.showSubProcess && !me.showNormal){
        PF.message("info",$lang("未获取到符合条件的流向信息"));
        return;
      }
      me.setBtnLoading(true,0);
      function doCommit(params){
        if(me.params.fullAuthType){
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.batchCommit(params).then((res)=>{
            var data = res.result;
            if(data && !data.success){ //提交意见检查
              if(data.errorType=='comment'){
                  if(data.errorCode=='comment_check_stop'){
                    PF.message('info', $lang('您还没有填写意见,请填写意见'));
                     me.setBtnLoading(false,0);
                     return;
                  }else if(data.errorCode=='comment_check_remind'){
                     PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), {type: 'warning'}).then(()=>{
                          params['$directSave']=true;
                          doCommit(params);
                     }).catch(()=>{
                       me.setBtnLoading(false,0);
                     });
                     return;
                  }
              }else{
                me.setBtnLoading(false,0);
                var errorMsg = '';
                if(data.errorMsg){
                  errorMsg ='[错误信息:'+data.errorMsg+']';
                }
                PF.message('info', '完成失败'+errorMsg+'!');
                return;
              }
            }else{
              me.close();
              me.formActionComplete(params,res);
              me.setBtnLoading(false,0);
            }
        }).catch(()=>{
          me.setBtnLoading(false,0);
        });
      }

      if(me.allSelectTreeData.length==0 && me.curFlowId!=undefined){

        let flowData=undefined;
        me.allFlow.map((v)=>{
          if(v.id==me.curFlowId){
            flowData=v;
          }
        })

        if(flowData.activityId=='end'){//下一个节点是结束节点
          var params={};
          params.type="complete";
          params.isAddAttention=me.isAddAttention;
          params.taskId=me.params.taskId;
          params.appId=me.params.appId;
          params.formId=me.params.formId;
          params.formKey=me.params.formKey;
          params.entityId=me.params.entityId;
          params.businessId=me.params.businessId;
          params.activities=[{flowId:flowData.id,activityId:flowData.activityId}];

          if(me.comment){
            params.$comment=[{id:me.commentId,content:me.comment, category:me.commentCategory}];
          }
          params.formOpenSource=me.params.formOpenSource;
          doCommit(params);
        }else{
          me.setBtnLoading(false,0);
          PF.message("info",$lang("请先选择办理人员或者部门!"));
        }
      }else{
        let activities=[];
        me.allSelectTreeData.map(v=>{
          var activity={};
          activity.flowId=v.id;
          activity.activityId=v.activityId;
          activity.type=v.category;
          activity.options=v.options;
          var items=[];

          var options=v.options;

          if(options && options.activityUnit=='group'){//办理单位为部门
            v.children.map(d=>{
              if(d.identities.length>0){//选择单位为部门或部门树、合并到上级
                  var item={};
                  item.group=d.originalId; //.split('|')[0];
                  d.identities.map(i=>{
                     if(i.type=='U'){
                        if(!item.users){
                            item.users=[];
                        }
                        if(i.id.indexOf("_")>-1){
                          item.users.push({id:i.id.split("_")[1]});
                        }else{
                          item.users.push({id:i.id});
                        }
                     }else{
                        if(!item.identities){
                           item.identities=[];
                        }
                        item.identities.push({id:i.id});
                     }
                  });
                  items.push(item);
              }else{
                /*
                var item=undefined;
                items.map(i=>{
                  if(i.group==d.parentId){
                    item=i;
                  }
                })
                if(item){
                  //d.id.split('|')[0]
                  if(d.originalId.indexOf("_")>-1){
                    item.users=[{id:d.originalId.split("_")[1]}];
                  }else{
                    item.users=[{id:d.originalId}];
                  }

                }else{
                */
                  var item={};
                  item.group=d.parentId;
                  if(d.originalId.indexOf("_")>-1){
                    item.users=[{id:d.originalId.split("_")[1]}];
                  }else{
                    item.users=[{id:d.originalId}];
                  }
                  items.push(item);
                  /*
                }
              */
              }
            });
          }else{ //办理单位为用户
            v.children.map(d=>{
              var item={};
              if(d.identities.length>0){ //选择单位为部门或部门树、合并到上级
                  item.group=d.originalId; //.split('|')[0];
                  d.identities.map(i=>{
                     if(i.type=='U'){
                        if(!item.users){
                            item.users=[];
                        }
                       if(i.id.indexOf("_")>-1){
                         item.users.push({id:i.id.split("_")[1]});
                       }else{
                         item.users.push({id:i.id});
                       }
                     }else{
                        if(!item.identities){
                           item.identities=[];
                        }
                        item.identities.push({id:i.id});
                     }
                  });
              }else{
                if (v.options.singleDepartmentRecord==="true") { //人员运转，部门内抢办，把部门人员合一起只发一个
                  item=items.filter(it=>it.group===d.parentId)[0];
                  if (!item) {
                    item={
                      group:d.parentId,
                      users:[]
                    }
                  }
                  item.users.push({id:d.originalId.split("_").pop()});
                }else{
                  item.group=d.parentId;
                  //d.id.split('|')[0]
                  if(d.originalId.indexOf("_")>-1){
                    item.users=[{id:d.originalId.split("_")[1]}];
                  }else{
                    item.users=[{id:d.originalId}];
                  }
                }
              }
              if(items.indexOf(item)<0)items.push(item);
            });
          }
          activity.items=items;
          activities.push(activity);
        })
        var params={};
        params.type="complete";
        params.isAddAttention=me.isAddAttention;
        params.reminders = me.tipCheckList.join(",");
        params.tipContent = me.tipContent;
        params.taskId=me.params.taskId;
        params.appId=me.params.appId;
        params.formId=me.params.formId;
        params.formKey=me.params.formKey;
        params.entityId=me.params.entityId;
        params.businessId=me.params.businessId;
        params.activities=activities;
        if(me.comment){
          params.$comment=[{id:me.commentId,content:me.comment, category:me.commentCategory}];
        }
        params.formOpenSource=me.params.formOpenSource;
        if(_.isFunction(me.params.beforedocomplete)){
          if(me.params.beforedocomplete.call(me,params,function(){doCommit(params)})===false)
            return;
        }
        doCommit(params);
      }
    },
    selectClick(){
      let me=this;
      let hide=true;
      let flowData=undefined;
      me.allFlow.map((v)=>{
        if(v.id==me.curFlowId){
          flowData=v;
        }
      })
      /*if(!flowData.options.multipleUnit) {
        let selectFlowData = undefined;
        me.allSelectTreeData.map((v) => {
          if (v.id == me.curFlowId) {
            selectFlowData = v;
          }
        })

        if (selectFlowData) {
          hide = false;
        }
      }*/
      let data = me.$refs["tree"+me.curFlowId][0].getSelectNodes(); //兼职me.curFlowId为X155774490964906894185195458328|X15577448020990517076581723988这种格式的
      //let data =me.mwRef('tree'+me.curFlowId)[0].getSelectNodes();
      data.map(v=>{
          me.dblClick(v,v.parentId);
      })
    },
    deselectClick(){
      let me=this;
      let tree=me.mwRef('selectedTree');
      let nodes=tree.getSelected();
      if(!nodes)return;
      nodes.forEach(n => {
        if(n.type)tree.dblClickNodeId(n.id);
      });
    },
    dblClick(data,parentId,callback){ //移入
      let me=this;
      let flowData=undefined;
      me.allFlow.map((v)=>{
        if(v.id==me.curFlowId){
          flowData=v;
        }
      })

      let selectFlowData=undefined;
      me.allSelectTreeData.map((v)=>{
        if(v.id==me.curFlowId){
          selectFlowData=v;
        }
      })

      if(!flowData.options.multipleUnit){
        if(selectFlowData){
          me.mwRef('selectedTree').dblClickNodeId(selectFlowData.id)
          selectFlowData=undefined;
        }
      }
      if(callback)
        callback();
      if(selectFlowData){
        //selectFlowData.id+"|"+data.id+"|"+parentId
        selectFlowData.children.push({id:data.id+"|"+parentId+"|"+selectFlowData.id, originalId:data.id, flowId:selectFlowData.id,parentId:parentId,text:data.name,children:false,type:'file', identities:data.identities?data.identities:[]});
      }else{
        var node=Object.assign({state:{opened:true}},flowData);
        node.category=flowData.type;
        node.text=me.transFlowName(flowData.name)
        delete node.type;
        //flowData.id+"|"+data.id+"|"+parentId
        node.children=[
          // {id:data.id+"|"+parentId+"|"+flowData.id, originalId:data.id,flowId:flowData.id, parentId:parentId,text:data.name,type:'file',children:false, identities:data.identities?data.identities:[]}
          {id:data.id+"|"+parentId+"|"+flowData.id, originalId:data.id,flowId:flowData.id, parentId:parentId,text:(node.activityName&&node.activityName=='结束')?'结束':data.name,type:'file',children:false, identities:data.identities?data.identities:[]}
        ];
        me.allSelectTreeData.push(node);
      }
      me._validDisable();

      var normalSelect=[];
      me.allSelectTreeData.forEach(v=>{
        if(v.category=='normal'){
          normalSelect.push(v);
        }
      })
      if(normalSelect.length>1){
        normalSelect.forEach(v=>{
          if(v.id!=me.curFlowId){
            for(var i=0;i<me.allSelectTreeData.length;i++){
              if(me.allSelectTreeData[i].id==v.id){
                me.dblClickSelected(me.allSelectTreeData[i]);
                break;
              }
            }
          }
        })
      }
      me.mwRef('selectedTree').refreshData(me.allSelectTreeData);
    },
    selectAll(){
      var me = this;
      var checkedSelectAll = me.checkedSelectAll;
      if(checkedSelectAll && checkedSelectAll==true && me.curFlowId!=undefined){
        var tree = me.mwRef("tree"+me.curFlowId)[0];
        if(tree) $(tree.$el.querySelector('.mw-tree')).jstree("select_all")
      }else if(checkedSelectAll==false && me.curFlowId!=undefined){
        var tree = me.mwRef("tree"+me.curFlowId)[0];
        if(tree) $(tree.$el.querySelector('.mw-tree')).jstree("deselect_all")
      }
    },
    _showSelectAllBtn(conf){
      var me = this;
      if(conf.type=="startSubProcess" && conf.options && conf.options.sendUnit=="DEP" && !window.$Env.hideProcessSelectAllBtn){
        me.showSelectAllBtn = true;
      }else{
        me.showSelectAllBtn = false;
      }
    },
    _validDisable(){
      let me=this;
      if(me.normalFlow.length>0 && me.subProcessFlow.length>0){
        let waits=[];
        me.subProcessFlow.forEach(v=>{
          if('1'==v.options.waitComplete){
            waits.push(v);
          }
        })
        if(waits.length>0){
          let normal=false;
          let startSubProcess=false;
          for(let i=0;i<me.allSelectTreeData.length;i++){
            let v=me.allSelectTreeData[i];
            if(v.category=='normal'){
              normal=true;
              break;
            }
            if(v.category=='startSubProcess' && '1'==v.options.waitComplete){
              startSubProcess=true;
              break;
            }
          }
          if(normal){
            me.normalFlow.forEach(v=>{
              v.$disabled=false;
            })
            waits.forEach(v=>{
              v.$disabled=true;
            })
          }else if(startSubProcess){
            me.normalFlow.forEach(v=>{
              v.$disabled=true;
            })
            waits.forEach(v=>{
              v.$disabled=false;
            })
          }else{
            me.normalFlow.forEach(v=>{
              v.$disabled=false;
            })
            waits.forEach(v=>{
              v.$disabled=false;
            })
          }
        }
      }
    },

    dblClickSelected(data,el){ //移除
      let me=this;
      if(data.type){
        //let ids=data.id.split('|');
        me.mwRef('tree'+data.flowId)[0].showNode(data.originalId);  //ids[0]

        let selectFlowData=undefined;
        let idx=-1;
        me.allSelectTreeData.map((v,d)=>{
          if(v.id==data.flowId){
            selectFlowData=v;
            idx=d;
          }
        })
        let sIdx=-1;
        selectFlowData.children.map((v,d)=>{
          //let vids=v.id.split('|');    ids[0]==vids[0]
          if(data.originalId==v.originalId){
            sIdx=d;
          }
        })
        me.allSelectTreeData[idx].children.splice(sIdx,1)

      }else{
        let selectFlowData=undefined;
        let idx=-1;
        me.allSelectTreeData.map((v,d)=>{
          if(v.id==data.id){
            selectFlowData=v;
            idx=d;
          }
        })
        selectFlowData.children.map((v)=>{
          me.$refs["tree"+v.flowId][0].showNode(v.originalId);
          //me.mwRef('tree'+v.flowId)[0].showNode(v.originalId);//ids[0]
        })
        me.allSelectTreeData.splice(idx,1);
      }
      me._validDisable();
    },
    flowClick(conf,event,type){
      var me=this;
      let flowData=undefined;
      me.allFlow.map((v)=>{
       if(v.id==conf.id){
         flowData=v;
       }
     })
      if(flowData.$disabled){
        return;
      }
      me.curFlowId=conf.id;
      me.curFlowName=conf.name;
      me._showSelectAllBtn(conf);
      me.loadFlowDeptUser(flowData);
    },

    init(){
      var me=this;
      if(me.params.comment && me.params.comment.length>0){
        me.comment=me.params.comment[0].content;
        me.commentId=me.params.comment[0].id;
        me.commentCategory=me.params.comment[0].category;
      }else{
        me.commentId=$uuid();
        me.comment='';
        me.commentCategory=me.params.activity.commentCategory;
      }

      bpmTaskApi.getTaskFlow({taskId:me.params.taskId})
        .then(data=>{
          if(data.length==0){
            return;
          }else{
            var normal=[];
            var subProcess=[];
            data.map((d)=>{
              if(d.type==='normal'){
                normal.push(d)
              }else if(d.type==='startSubProcess'){
                subProcess.push(d)
              }
              me.allFlow.push(d);
            })
            if(normal.length>0){
              me.normalFlow=normal;
              me.showNormal=true;
              // me.curFlowId=normal[0].id;
              // me.curFlowName=normal[0].name;
              //me.params.activity.densityNode定密节点不判断
              if (normal.length === 1 && subProcess.length === 0 && !me.showCircular && (!me.params.activity || me.params.activity.densityNode!="1")) {
                PF.api.data.getSysFormDic().then(res=>{
                  if (res.success && res.result && res.result.flowOneShowCompleteDilog==='0') {
                    //只有一个流向，去找一下人员看看是否只有一个人，可能就不需要弹出完成对话框。
                    $.ajax({
                      url:`/rest/process/task/flow/${me.params.taskId}/${normal[0].id}?returnTree=undefined`,
                      success:function(d){
                        function isSingleFlow(tree){
                          if(!tree || tree.length!==1)return false;
                          if(!tree[0].children || tree[0].children.length===0){
                            return !tree[0].hasChild
                          }else{
                            return isSingleFlow(tree[0].children)
                          }
                        }

                        if (isSingleFlow(d)) {
                          me.submitSingleFlow(normal[0],d);
                        }else{
                          //me.loadFlowDeptUser(normal[0],d);
                          handleSubProcess();
                        }
                      }
                    })
                  }else{
                    //me.loadFlowDeptUser(normal[0]);
                    handleSubProcess();
                  }
                });

              }else{
                //this.loadFlowDeptUser(normal[0]);
                handleSubProcess();
              }
            }else{
              handleSubProcess();
            }
            function findDefaultSelectFlow(){
              let activity=me.params.defaultSelectActivity;
              let isMatch=o=>o.id===activity || o.name===activity || o.activityId===activity || o.activityName===activity
              return _.find(normal,isMatch) || _.find(subProcess,isMatch) || normal[0] || subProcess[0];
            }

            function handleSubProcess(){
              let defaultSelectFlow=findDefaultSelectFlow();
              if(subProcess.length>0){
                me.showSubProcess=true;
                me.subProcessFlow=subProcess;
              }
              if(!me.curFlowId){
                me.curFlowId=defaultSelectFlow.id;
                me.curFlowName=defaultSelectFlow.name;
                me._showSelectAllBtn(defaultSelectFlow);
                me.loadFlowDeptUser(defaultSelectFlow);
              }
              me.flowCount=subProcess.length+normal.length;
              me.autoSelCandidate(defaultSelectFlow);
              me.show();
            }
          }
          return data;
      });
      var activity=me.params.activity;

      if(activity && activity.circularSwitch==1){
        let flowData={};
        flowData.id=activity.id;
        flowData.activityId=activity.id;
        flowData.name=$lang("传阅人员");
        flowData.type="circular";
        let options={};
        options.multipleUnit=true;
        flowData.options=options;
        var circular=[];
        circular.push(flowData);
        me.circularFlow=circular;
        me.showCircular=true;
        me.allFlow.push(flowData);
      }
    },
    autoSelCandidate(flow){
      let me = this;
      //只有一条流向，且流向配置了表单域值，自动选中
      if(me.flowCount==1){
        if(flow.options.groupType=='biz' || flow.options.userType=='biz'){
            me.autoSelectData = true;
        }
      }
    },
    submitSingleFlow(flowData,data) {
      let me=this;
      function getDeepNode(node,parent) {
        if(!node || !node.children) return {node,parent};
        return getDeepNode(node.children[0],node)
      }

      let obj=getDeepNode(data[0]);
      data=obj.node;
      let parentId=obj.parent && obj.parent.id
      var node=Object.assign({state:{opened:true}},flowData);
      node.category=flowData.type;
      node.text=flowData.name
      delete node.type;
      node.children=[{
        id:data.id+"|"+parentId+"|"+flowData.id,
        originalId:data.id,
        flowId:flowData.id,
        parentId:parentId,
        text:data.name,
        type:'file',
        children:false,
        identities:data.identities || []
      }];
      me.allSelectTreeData.push(node);
      me.isSubmitSingleFlow=true;
      me.submit();
    },
    loadFlowDeptUser(conf,rootData){
      let me=this;
      //me.flowId=conf.id;
      let flowId=conf.id.replace(/-/g, '_');

      if(me.curTreePanel){
        me.curTreePanel.vshow=false;
      }

      if(!me.deptTreePanel[flowId]){
        let multiple = conf.options.multipleUnit;
        let o;
        if(conf.type!='circular'){
          o={vshow:true,rootData,activityId:conf.activityId,type:conf.type,vif:true,url:`/rest/process/task/flow/${me.params.taskId}/${conf.id}`, multiple:multiple, defaultParams:{returnTree:conf.options.returnTree}};
        }else{
          o={vshow:true,rootData,activityId:conf.activityId,type:conf.type,vif:true,url:`/rest/process/task/circular/${me.params.taskId}`, multiple:multiple};
        }
        this.$set(me.deptTreePanel,flowId,o)
      }else{
        me.deptTreePanel[flowId].vshow=true;
      }

      me.curTreePanel=me.deptTreePanel[flowId];

    },

    getTitle(title){
      this.title=title;
    },
    beforeClose(done){
      var me=this;
      //me.mwConfirm('确认退出完成？').then(_ => {
        if(me.params.secondfunc){
          me.params.secondfunc()
        }
        me.resetForm();
        done();
      // }).catch(_ => {
      // });
    },
    resetForm(){
      var me=this;
      this.curFlowId=undefined;
      this.curFlowName='';
      this.allFlow=[];
      this.normalFlow=[];
      this.subProcessFlow=[];
      this.circularFlow=[];
      this.allSelectTreeData=[];
      this.deptTreePanel={};
      this.curTreePanel=undefined;
      this.showCircular=false;
      this.showNormal=false;
      this.showSubProcess=false;
      this.flowCount=0;
      this.commentId='';
      this.comment='';
      this.commentCategory='';

      if(me.mwRef('selectedTree'))me.mwRef('selectedTree').refreshData(me.allSelectTreeData);
    },

    formActionComplete(params,res){
      let me=this;
      if(me.params.func){
        me.params.func(params,res)
      }
      this.resetForm();
    },

    show(){
      let me = this;
      if(_.isFunction(me.params.beforeshowdialog)){
        if(me.params.beforeshowdialog.call(me)===false)
          return;
      }
      me.mwRef('dialog').show();
      if(me.customBottom && me.customBottomComp){
        me.$nextTick(()=>{
          $(me.$refs.customBottom.$el).html(me.customBottomComp.$mount().$el);
        })
      }
    },
    close(){
      this.resetForm();
      this.beforeClose(o => {
        if(this.mwRef('dialog'))this.mwRef('dialog').hide();
      });
    }
  }
}
</script>

<style>
  .prompt-dialog-big-input textarea{
    height: 150px;
  }
  .prompt-dialog-big-input{
    width: 500px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/public-dialog/complete.vue